import { SourceSystem } from './admin-enum.service';

import {
   // rand,
   randNumber,
   randBoolean,
   randProductName,
   randAccessory,
   randDrinks,
} from '@ngneat/falso';

export const MockSourceSystem = (): SourceSystem => {
   const keys = Array.from({ length: randNumber({ max: 20 }) }, _ => randDrinks() );
   console.log( 'keys', keys.length );

   const services = Array.from({ length: randNumber({ max: 20 }) }, ( _, i ) => ({
      id: i,
      service: randAccessory(),
      required_keys: Array.from({ length: randNumber({ min: 1, max: keys.length, precision: 1 }) }, ( _, i ) => keys[i] ),
   }));

   return {
      name: randProductName(),
      keys: Array.from({ length: randNumber({ min: 1, max: keys.length, precision: 1 })}, ( _, i ) => ({
         key: keys[i],
         default: randBoolean() ? randDrinks() : undefined,
      })),
      services: Array.from({ length: randNumber({ max: services.length })}, ( _, i ) => services[i] ),
      // services: rand( services, { length: randNumber({ max: services.length })}),
      environment: 'DEV',
   };
}

export const CustomerPortalSourceSystems: SourceSystem[] = [
   {
      name: 'SAPTM',
      keys: [
         { key: 'accountingId', default: 'testing' },
         { key: 'sapTmBp' },
      ],
      services: [
         { id: 2, service: 'DOMESTIC QUOTING' },
         { id: 3, service: 'DOMESTIC BOOKING', required_keys: ['sapTmBp'] },
         { id: 4, service: 'DOMESTIC TRACKING', required_keys: ['sapTmBp'] },
         { id: 5, service: 'DOMESTIC INVOICING', required_keys: ['sapTmBp', 'accountingId'] },
         { id: 6, service: 'INTERNATIONAL QUOTING' },
         { id: 7, service: 'INTERNATIONAL BOOKING', required_keys: ['sapTmBp'] },
         { id: 8, service: 'INTERNATIONAL TRACKING', required_keys: ['sapTmBp'] },
         { id: 9, service: 'INTERNATIONAL INVOICING', required_keys: ['sapTmBp', 'accountingId'] },
         { id: 10, service: 'OCEAN QUOTING' },
         { id: 11, service: 'OCEAN BOOKING', required_keys: ['sapTmBp'] },
         { id: 12, service: 'OCEAN TRACKING', required_keys: ['sapTmBp'] },
         { id: 13, service: 'OCEAN INVOICING', required_keys: ['sapTmBp', 'accountingId'] },
      ],
      environment: 'DEV',
   },
   {
      name: 'Other Source System',
      keys: [
         { key: 'external_key' },
      ],
      services: [
         { id: 3, service: 'DOMESTIC BOOKING', required_keys: ['external_key'] },
         { id: 4, service: 'DOMESTIC TRACKING' },
         { id: 7, service: 'INTERNATIONAL BOOKING' },
         { id: 8, service: 'INTERNATIONAL TRACKING' },
      ],
      environment: 'DEV',
   }
];

export const FourPlPortalSourceSystems: SourceSystem[] = [
   {
      name: 'SAPTM',
      keys: [
         { key: 'sapTmBp' },
         { key: 'accountingId', default: 'testing' },
         { key: 'tracking', default: 'hawb' },
      ],
      services: [
         { id: 2, service: 'DOMESTIC QUOTING' },
         { id: 3, service: 'DOMESTIC BOOKING', required_keys: ['sapTmBp'] },
         { id: 4, service: 'DOMESTIC TRACKING', required_keys: ['sapTmBp', 'tracking'] },
         { id: 5, service: 'DOMESTIC INVOICING', required_keys: ['sapTmBp', 'accountingId'] },
         { id: 6, service: 'INTERNATIONAL QUOTING' },
         { id: 7, service: 'INTERNATIONAL BOOKING', required_keys: ['sapTmBp'] },
         { id: 8, service: 'INTERNATIONAL TRACKING', required_keys: ['sapTmBp', 'tracking'] },
         { id: 9, service: 'INTERNATIONAL INVOICING', required_keys: ['sapTmBp', 'accountingId'] },
         { id: 10, service: 'OCEAN QUOTING' },
         { id: 11, service: 'OCEAN BOOKING', required_keys: ['sapTmBp'] },
         { id: 12, service: 'OCEAN TRACKING', required_keys: ['sapTmBp', 'tracking'] },
         { id: 13, service: 'OCEAN INVOICING', required_keys: ['sapTmBp', 'accountingId'] },
      ],
      environment: 'DEV',
   },
   {
      name: 'Other Source System',
      keys: [
         { key: 'external key' },
         { key: 'external key with value', default: 'value' },
      ],
      services: [
         { id: 3, service: 'DOMESTIC BOOKING', required_keys: ['external key', 'external key with value'] },
         { id: 4, service: 'DOMESTIC TRACKING', required_keys: ['external key', 'external key with value'] },
         { id: 7, service: 'INTERNATIONAL BOOKING', required_keys: ['external key', 'external key with value'] },
         { id: 8, service: 'INTERNATIONAL TRACKING', required_keys: ['external key', 'external key with value'] },
      ],
      environment: 'DEV',
   }
];

export const VendorPortalSourceSystems: SourceSystem[] = [
   {
      name: 'sapTm',
      keys: [
         { key: 'sapTmBp' },
      ],
      services: [
         { id: 1, service: 'Cartage' },
      ],
      environment: 'DEV',
   },
];

export const SourceSystems: {[ key: string ]: SourceSystem[] } = {
   customer: CustomerPortalSourceSystems,
   vendor: VendorPortalSourceSystems,
   '4pl': FourPlPortalSourceSystems,
   agent: [],
};

// export const Services = [ ...new Set( SourceSystems.map( ss => ss.services )
//    .reduce(( a, c ) => [ ...a, ...c ], [] ) )];
// console.log( 'Services', Services );
// console.log( 'Keys', Keys );
// console.log( 'SourceSystemNames', SourceSystemNames );

